import React from 'react';
import { ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, PRICE_FULL, PRICE_TODAY, PRODUCT_ALT, PRODUCT_IMG } from './constants';
export function PricingCard() {
  return <section id="offer" className="border-y-4 border-brand-gold bg-brand-light px-4 py-4" data-id="element-103" data-mp="1m4t9m0pdxwce">
      <div className="mx-auto max-w-2xl" data-id="element-104" data-mp="1i40yf1wydhdh">
        <div className="mb-2 text-center" data-id="element-105" data-mp="2esywat001vev">
          <p className="mb-0.5 font-head text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-blue sm:text-sm" data-id="element-106" data-mp="2erx95q5pligs">
            Special Launch Offer
          </p>
          <h2 className="mb-0.5 font-display text-3xl uppercase leading-none tracking-wide sm:text-5xl" data-id="element-107" data-mp="252x5htg9hyw9">
            VOLLEYBALL COACH PRO™
          </h2>
          <p className="mb-1.5 font-head text-[13px] font-semibold uppercase text-brand-navy sm:text-lg" data-id="element-108" data-mp="211bp3y4ir2hb">
            Complete 6-in-1 Volleyball Coaching System
          </p>
          <a href={CHECKOUT_URL} className="block" aria-label="Buy VOLLEYBALL COACH PRO™" data-id="element-109" data-mp="2sry993e5glv7">
            <img src={PRODUCT_IMG} alt={PRODUCT_ALT} className="mx-auto mb-2 w-full max-w-[230px] object-contain drop-shadow-xl transition-transform duration-200 ease-out hover:scale-[1.02] sm:max-w-[260px]" data-id="element-110" data-mp="32ldk70tf0usj" />
          </a>
        </div>

        <div className="mb-2 rounded-xl border-4 border-brand-gold bg-white p-4 text-center shadow-2xl" data-id="element-111" data-mp="2xsu682qtfxn7">
          <ul className="mb-1.5 flex flex-wrap items-center justify-center gap-x-4 gap-y-0.5 text-[13px] font-semibold text-brand-navy sm:text-base" data-id="element-112" data-mp="2jst64pidku8s">
            <li data-id="element-113" data-mp="2oqkz7muramek">✅ 6 Complete Modules</li>
            <li data-id="element-114" data-mp="29wgh44xrz4kd">✅ 5 Premium Bonuses</li>
          </ul>
          <p className="text-[13px] font-medium text-brand-muted" data-id="element-115" data-mp="29y19bnwmabf2">
            Regular Price: <span className="line-through" data-id="element-116" data-mp="2ev013zst66a3">{PRICE_FULL}</span>
          </p>
          <p className="font-display text-2xl uppercase leading-none tracking-wide text-brand-blue sm:text-4xl" data-id="element-117" data-mp="85lg8yopof6s">
            🔥 TODAY ONLY: {PRICE_TODAY}
          </p>
          <p className="mb-2.5 mt-0.5 text-[11px] font-medium text-brand-muted" data-id="element-118" data-mp="bmr0j0hmlas3">
            Secure payment in your local currency.
          </p>
          <CTAButton href={CHECKOUT_URL} data-id="element-119" data-mp="6ljv382ygnol">🚀 YES! I WANT VOLLEYBALL COACH PRO™</CTAButton>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] font-semibold text-brand-navy sm:text-sm" data-id="element-120" data-mp="1obl3urynpyf">
          <span className="flex items-center gap-1" data-id="element-121" data-mp="ucfsqlu3ed3r">
            <StarIcon className="h-4 w-4 fill-brand-gold text-brand-gold" aria-hidden="true" data-id="element-122" data-mp="uc7h0x9phdu5" />
            ⭐⭐⭐⭐⭐ 4.9/5 — Verified Customer Reviews
          </span>
          <span className="flex items-center gap-1" data-id="element-123" data-mp="km4bxypb89fg">
            <ShieldCheckIcon className="h-4 w-4 text-brand-blue" aria-hidden="true" data-id="element-124" data-mp="kkt6lug7utm8" />
            🛡️ 14-Day Money-Back Guarantee
          </span>
        </div>
      </div>
    </section>;
}